import { Control } from 'react-hook-form'

import { Input, DateTimeInput } from '@presentation/components/molecules'
import { InputProps } from '@presentation/types/components/molecules'

type DescriptionInputProps = InputProps & {
  control: Control
}

const DescriptionInput: React.FC<DescriptionInputProps> = ({
  type,
  name,
  register,
  control
}) => {
  if (type === 'datetime-local') {
    return <DateTimeInput control={control} name={name} />
  }

  return <Input type={type} name={name} register={register} required />
}

export default DescriptionInput
